<dialog
#modal
class="root-container"
dialogBackdrop>
  @if (!locked) {
    <i
    class="bi bi-x-lg close-button"
    (click)="onDismiss()"></i>
  }
  <div class="title">{{ title }}</div>
  <div [class]="['message', align]">{{ message }}</div>
  @if(type === 'confirm-warning' && second_message) {
  <div [class]="['message', align]">{{ second_message }}</div>
  }
  <div class="button-container" >
    @if (type == "confirm" || type == 'confirm-warning') {
      <button-component
      [text]="negative_text"
      type="default"
      (click)="negativeAction()" />
    } @if (type == 'info' || type == 'confirm') {
      <button-component
      [text]="positive_text"
      type="primary"
      (click)="positiveAction()" />
    } @if (type == 'confirm-warning') {
      <button-component
      [text]="positive_text"
      type="warning"
      (click)="positiveAction()" />
    }
  </div>
</dialog>
